import React from 'react';
import { Input, Button } from 'semantic-ui-react';
import Checkbox from '@material-ui/core/Checkbox';

class OtherCharge extends React.Component {

  state = {
    amount: 0,
    tax: 0
  }

  checkBox = name => event => {
    this.setState({ [name]: event.target.checked })
  }

  onChangehandle = name => event => {
    this.setState({ [name]: event.target.value })
  }

  submit() {
    let items = this.props.items;
    let i = 0;
    let id = 0;
    items.map((x) => {
      if (x.partname == 'OtherCharge') {
        id = x.id;
        i = 1;
      }
    })
    if (i == 1) {
      this.update(id);
    }
    else {
      let amount = this.state.amount;
      try {
        amount = Number(amount);
      } catch (e) {
      }
      let newId = 0;
      items.map((x) => {
        if (newId > x.id) {

        }
        else {
          newId = x.id;
        }
      })
      newId = newId + 1;
      items.push({aliasId: 0, branch: 1, brand: 1, brandname: '', dnp: amount, id: newId, invoice: 0,
                  invoice_date: 0, mrp: 0, part_id: 23, partcode: this.state.tax,
                  partname: 'OtherCharge', partno: 0, purchaser: this.props.selectedPurchaser,
                  stock: 1, tax: this.state.tax, total: amount});
      this.props.itemsUpdates(items);
    }
  }

  update(id) {
    let array = this.props.items;
    let amount = this.state.amount;
    let tax = this.state.tax;
    try {
      amount = Number(amount);
      tax = Number(tax);
    } catch (e) {
    }
    for (var i = 0; i < array.length; i++) {
      if (id == array[i].id) {
        array[i].total = amount;
        array[i].tax = tax;
        array[i].dnp = amount;
      }
    }
    this.props.itemsUpdates(array);
  }

  render() {
    return (
      <div>
        { this.props.items.length >= 1 ?
          (
            <div style={{display: 'flex'}}>
              <Checkbox checked={this.state.check} onChange={this.checkBox('check')}
                value="Check" />
              <div><br/>Other Charge`s</div>
            </div>
          ):
          (
            <div></div>
          )
        }
        { this.state.check == true ?
          (
            <div style={{display: 'flex'}}>
              <Input onChange={this.onChangehandle('amount')} placeholder='Amount' type='number' value={this.state.amount} /><br/>
              <Input onChange={this.onChangehandle('tax')} type='number' placeholder='Tax' value={this.state.tax} /><br/>
              <Button onClick={this.submit.bind(this)}>Submit</Button>
            </div>
          ) :
          (
            <div></div>
          )
        }
      </div>
    );
  }
}

export default OtherCharge;
